export default __webpack_public_path__ + "bg_day_big.0ed5fff.svg";